import { lighten } from "polished";
import { FC, ReactNode } from "react";
import styled from "styled-components";

interface IProps {
  children: {
    top: ReactNode;
    content: ReactNode;
    bottom: ReactNode;
  };
}

const RootContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 0;
  flex-shrink: 0;
  height: 100%;
  width: 100%;
`;

const TopContainer = styled.div`
  width: 100%;
  height: 5rem;
`;

const ContentContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  // TODO move from layout to container
  ::-webkit-scrollbar {
    width: 0.6rem;
  }

  ::-webkit-scrollbar-thumb {
    background: ${props => props.theme.selected};
    border-radius: 9999px;
    cursor: pointer;

    :hover {
      background-color: ${props => lighten(0.05, props.theme.selected)};
    }
  }
`;

const BottomContainer = styled.div`
  width: 100%;
  height: 8rem;
`;

const TaskListLayout: FC<IProps> = ({ children }) => {
  const { top, content, bottom } = children;

  return (
    <RootContainer>
      <TopContainer>{top}</TopContainer>
      <ContentContainer>{content}</ContentContainer>
      <BottomContainer>{bottom}</BottomContainer>
    </RootContainer>
  );
};

export default TaskListLayout;
